import React, { useState, useRef, useEffect } from "react";
import TrapFocus from "@mui/material/Unstable_TrapFocus";
import {
  Box,
  Typography,
  Fade,
  Stack,
  Paper,
  Button,
  Skeleton,
  IconButton,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Typewriter from "typewriter-effect";
import Logo from "../../assets/img/home/main/logo.png";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import {
  ActionDiv,
  ChatHeaderContainer,
  ChatLogo,
  Input,
} from "../../styles/dashboard/DashboardHomeStyle";
import { GetAnswersToPrompt } from "../../redux/actions/fieldManagement";
import { connect } from "react-redux";

const ChatDashboardAI = (props) => {
  const typewriterRef = useRef(null);

  const { open, handleClose, GetAnswersToPrompt } = props;
  const [userInput, setUserInput] = useState("");
  const [prompt, setPrompt] = useState(null);
  const [conversation, setConversation] = useState([]);
  const [fetching, setFetching] = useState(false);

  //handle Saving of Prompts
  const handlePromptSave = (message) => {
    setConversation([
      ...conversation,
      {
        id: conversation?.length + 1,
        text: message,
        type: "prompt",
        time: moment(new Date()).format("hh:mm:a"),
      },
    ]);

    if (userInput) {
      setUserInput("");
    }
  };

  //handle input change
  const handleUserInput = (e) => {
    setUserInput(e.target.value);
  };
  //close and clear all prompts and inputs state
  const onCloseAll = () => {
    handleClose();
    setUserInput("");
    setPrompt("");
    setConversation([]);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      handlePromptSave(userInput);
    }
  };

  const scrollIntoView = () => {
    if (typewriterRef?.current) {
      typewriterRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  };

  //async action
  const getAIAnswersToPrompt = async (payload) => {
    setFetching(true);
    setConversation([
      ...conversation,
      { id: conversation?.length + 1, text: "loading", type: "response" },
    ]);
    const res = await GetAnswersToPrompt(payload);
    setFetching(false);
    setConversation([
      ...conversation,
      {
        id: conversation?.length + 1,
        text: res?.message,
        type: "response",
        time: moment(new Date()).format("hh:mm:a"),
      },
    ])?.filter((item) => item?.text !== "loading");
  };

  useEffect(() => {
    if (conversation?.[conversation.length - 1]?.type === "prompt") {
      // as long after prompt is saved, make request; don't watch for change in user prompt
      getAIAnswersToPrompt({
        question: conversation?.[conversation.length - 1]?.text,
      });
    }

    // scrolls into view if is response and is the last convo item
    if (
      conversation?.[conversation.length - 1]?.type === "response" &&
      conversation?.[conversation.length - 1].id === conversation.length
    ) {
      scrollIntoView();
    }
  }, [conversation]);

  const replaceWithLinkeBreakers = (text) =>
    text?.replaceAll(/\n/g, "<br>") ?? null;
  useEffect(() => {
    if (open) {
      setPrompt({
        text: "Hello 👋 How may i be of help?",
        time: moment(new Date()).format("hh:mm:a"),
      });
    }
  }, [open]);
  return (
    <TrapFocus open disableAutoFocus disableEnforceFocus>
      <Fade appear={true} in={open}>
        <Paper
          role="dialog"
          aria-modal="false"
          aria-label="Cookie banner"
          square
          variant="outlined"
          tabIndex={-1}
          sx={{
            position: "fixed",
            bottom: "28%",
            right: "8%",
            m: 0,
            p: 0,
            width: "400px",
            maxHeight: "60vh",
            height: "100%",
            minHeight: "300px",
            borderRadius: "10px",
            backgroundColor: "white",
            zIndex: 10000000,
          }}
        >
          <div
            style={{
              position: "relative",
              height: "59vh",
            }}
          >
            <ChatHeaderContainer>
              <Box
                sx={{
                  p: 2,
                  height: "70px",
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <ChatLogo src={Logo} alt="logo" />
                    <Typography sx={{ fontWeight: "bolder " }}>
                      Talk to AgroBot.
                    </Typography>
                  </Box>

                  <IconButton onClick={onCloseAll}>
                    <CloseIcon sx={{ color: "#ffffff" }} />
                  </IconButton>
                </Stack>
              </Box>
            </ChatHeaderContainer>
            <Box
              sx={{
                flexGrow: 1,
                overflowY: "auto",
                px: 1.5,
                pt: 3,
                display: "flex",
                flexDirection: "column",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <div className="pb-4">
                {open && prompt && (
                  <div>
                    <Box
                      sx={{
                        backgroundColor: "#F1F5F9",
                        mt: 0.5,
                        px: 2,
                        borderRadius: "0px 24px 24px 24px",
                        width: "fit-content",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          p: 1,
                          fontSize: 12,
                          fontWeight: 400,
                          color: "#334155",
                        }}
                      >
                        <Typewriter
                          onInit={(typewriter) => {
                            typewriter
                              .typeString(
                                replaceWithLinkeBreakers(prompt?.text)
                              )
                              .callFunction(() => {
                                console.log("String typed out!");
                              })
                              .changeDelay(10)
                              .start();
                          }}
                          options={{
                            loop: false,
                            delay: "10",
                            deleteSpeed: 0,
                          }}
                        />
                      </Typography>
                    </Box>
                    <p
                      style={{
                        color: "#94A3B8",
                        fontSize: "12px",
                        textTransform: "uppercase",
                        fontWeight: 400,
                        marginTo: 2,
                      }}
                    >
                      {prompt?.time}
                    </p>
                  </div>
                )}
              </div>

              <Box
                sx={{
                  display: "grid",
                  flexDirection: "column",
                  height: "31vh",
                  overflow: "scroll",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                {conversation?.map((convo, index) => {
                  return (
                    <div
                      style={{
                        justifySelf: convo.type === "prompt" ? "end" : "start",
                      }}
                      ref={
                        convo.type === "response" &&
                        index === conversation.length - 1
                          ? typewriterRef
                          : null
                      }
                    >
                      <div>
                        {convo.type !== "prompt" && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <p
                              style={{
                                color: "#475569",
                                fontSize: "13px",
                                fontWeight: "bold",
                              }}
                            >
                              Us
                            </p>
                            <p
                              style={{
                                color: "#94A3B8",
                                fontSize: "12px",
                                textTransform: "uppercase",
                                fontWeight: 400,
                              }}
                            >
                              {convo?.time}
                            </p>
                          </div>
                        )}
                      </div>
                      {convo?.text === "loading" ? (
                        <Box
                          sx={{
                            backgroundColor: "#F1F5F9",
                            mb: 1.5,
                            px: 2,
                            borderRadius: "0px 10px 10px 10px",
                            width: "fit-content",
                            height: "35px",
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            mt: "-0.5rem",
                          }}
                        >
                          <Skeleton
                            animation="wave"
                            variant="circular"
                            width={10}
                            height={10}
                          />
                          <Skeleton
                            animation="wave"
                            variant="circular"
                            width={10}
                            height={10}
                          />
                          <Skeleton
                            animation="wave"
                            variant="circular"
                            width={10}
                            height={10}
                          />
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            backgroundColor:
                              convo.type === "prompt" ? "#0a4c3e" : "#F1F5F9",
                            mb: 0.5,
                            borderRadius:
                              convo.type === "prompt"
                                ? "5px 5px 0 5px"
                                : "0px 5px 5px 5px",
                            width: "fit-content",
                            minHeight: "35px",
                            padding: "0 5px",
                            height: "fit-content",
                            mt: "-0.5rem",
                          }}
                        >
                          <Typography
                            sx={{
                              p: 1,
                              fontSize: 12,
                              fontWeight: 400,
                              color:
                                convo.type === "prompt" ? "white" : "#334155",
                            }}
                            key={index}
                          >
                            {convo.type !== "prompt" ? (
                              <Typewriter
                                onInit={(typewriter) => {
                                  typewriter
                                    .typeString(
                                      replaceWithLinkeBreakers(convo?.text)
                                    )
                                    .callFunction(() => {
                                      console.log("String typed out!");
                                    })
                                    .changeDelay(10)
                                    .start();
                                }}
                                options={{
                                  loop: false,
                                  delay: "10",
                                  deleteSpeed: 0,
                                }}
                              />
                            ) : (
                              convo.text
                            )}
                          </Typography>
                        </Box>
                      )}
                      {convo.type !== "prompt" && (
                        <p
                          style={{
                            color: "#94A3B8",
                            fontSize: "12px",
                            textTransform: "uppercase",
                            fontWeight: 400,
                          }}
                        >
                          {convo?.time}
                        </p>
                      )}
                      {convo.type === "prompt" && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              color: "#94A3B8",
                              fontSize: "12px",
                              textTransform: "uppercase",
                              fontWeight: 400,
                            }}
                          >
                            {convo?.time}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </Box>
            </Box>
            <ActionDiv>
              <Input
                placeholder="Type your message..."
                value={userInput}
                onChange={handleUserInput}
                onKeyDown={handleKeyDown}
              />
              <Button
                variant="text"
                sx={{
                  minWidth: "unset",
                  p: 1.5,
                  basis: "10%",
                  backgroundColor: "transparent",
                  border: "1px solid white",
                  borderRadius: 30,
                }}
                onClick={() => handlePromptSave(userInput)}
                disabled={fetching}
              >
                <SendIcon size={20} sx={{ color: "#0a4c3e" }} />
              </Button>
            </ActionDiv>
          </div>
        </Paper>
      </Fade>
    </TrapFocus>
  );
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, {
  GetAnswersToPrompt,
})(ChatDashboardAI);
